export default __webpack_public_path__ + "static/media/Quality & Accreditations.2798b5ea.png";